var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckoutEssentials = function SvgCheckoutEssentials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#checkout-essentials_svg__a)",
    d: "M12 22.153 8.996 19.18H4.82v-4.175L1.846 12l2.975-3.005V4.82h4.175L12 1.846l3.004 2.974h4.175v4.175L22.154 12l-2.975 3.004v4.175h-4.175zm0-2.017 2.393-2.393h3.35v-3.35l2.393-2.394-2.393-2.392v-3.35h-3.35L12 3.862 9.607 6.256h-3.35v3.35L3.864 12l2.393 2.394v3.35h3.35z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "checkout-essentials_svg__a",
    x1: 12,
    x2: 12,
    y1: 1.846,
    y2: 22.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E43"
  })))));
};
export default SvgCheckoutEssentials;